import classnames from 'classnames';
import React from 'react';

import Icon from '@ant-design/icons';
import AddRuleIconSvg from '@icons/mapping-panel/add-rule-icon.svg';

import styles from './index.less';

interface IAddRuleButtonProps {
  text?: string;
  onClick?: (text: string) => void;
  disabled?: boolean;
  textStyle?: React.CSSProperties;
}

const AddRuleButton: React.FC<IAddRuleButtonProps> = ({
  text = '',
  onClick,
  disabled,
  textStyle,
}: IAddRuleButtonProps) => {
  const handleAddRuleClick = () => {
    !disabled && onClick?.(text);
  };

  return (
    <div
      className={classnames(styles.addRuleButton, { [styles.disabled]: disabled })}
      onClick={handleAddRuleClick}
    >
      <Icon component={AddRuleIconSvg} style={{ fontSize: 16 }} />
      <div className={styles.text} style={textStyle}>
        {text}
      </div>
    </div>
  );
};

export default AddRuleButton;
